document.addEventListener("DOMContentLoaded", () => {
    setTimeout(initCheckboxJS, 300)
})

function initCheckboxJS() {
    const inputs = document.querySelectorAll(".checkbox.blade")

    inputs.forEach((input) => {
        const toggleCheckbox = (checkbox) => {
            if (!checkbox.classList.contains("disabled")) {
                checkbox.classList.toggle("checked")
                checkbox.nextElementSibling.value = checkbox.classList.contains("checked") ? "1" : "0"
            }
        }

        const parent = input.parentNode
        if (parent.tagName.toUpperCase() === "LABEL") {
            parent.addEventListener("click", () => toggleCheckbox(input), {passive: true})
        } else {
            input.addEventListener("click", () => toggleCheckbox(input), {passive: true})
        }
    })
}
